import { IBuyableProduct } from './types';

export enum EEligibleProductsActionType {
  GET = 'ELIGIBLE_PRODUCTS_GET',
  GET_SUCCESS = 'ELIGIBLE_PRODUCTS_GET_SUCCESS',
}

export interface IGetEligibleProductsAction {
  type: EEligibleProductsActionType.GET;
}

export const getEligibleProductsAction = (): IGetEligibleProductsAction => ({
  type: EEligibleProductsActionType.GET,
});

export interface IGetEligibleProductsSuccessAction {
  type: EEligibleProductsActionType.GET_SUCCESS;
  payload: { products: IBuyableProduct[] };
}

export const getEligibleProductsSuccessAction = (
  products: IBuyableProduct[]
): IGetEligibleProductsSuccessAction => ({
  type: EEligibleProductsActionType.GET_SUCCESS,
  payload: { products },
});

export type IEligibleProductsAction =
  | IGetEligibleProductsAction
  | IGetEligibleProductsSuccessAction;
